import React from "react";
import styled from "styled-components";

const SideBySide = (props) => {
  return <Container {...props}>{props.children}</Container>;
};

export default SideBySide;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: var(--surface-50);
  border-bottom: 1px solid var(--surface-300);
  border-radius: 8px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
  max-height: 3.781rem;
  height: 3.781rem;
`;
